import { HttpProvider } from "../http/http.provider";
import { IAppConfig } from "../http/types/IApplicationConfig";
import { IBlockUnblockResponse, IUser, IUserResponse, IUserRoles, IUserRolecreate, IAddOrg, IAddClient, INewCraeteRole, IHMUserResponse, INewCreateDepartment, IDepartments, IDepartmentResponse, IMigrateLoginRequest, IOffboardUserRequest, IUserActionResponse,IUpdateUser}from"./userManagement.interface";
import { ServiceEndpointConstants } from "../ServiceUtil/consts/index";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { IHttpRequestConfig } from "../http/types/http.types";
import { INewProfilePic } from "../AuthenticationService/authentication.interface";
import { createFormData } from "../util/utilities";
import { IRoleUser } from "./userManagement.interface";
import { IUserRegistration, IUserRegistrationResponse } from "./userManagement.interface";

/**
 * User Management Delegate - handles HTTP communication for user management
 */
export class UserManagementDelegate {
    constructor(private SERVICE_CONFIG: IAppConfig, private http: HttpProvider) {
    }

    public getAllUsers(): Observable<IUserResponse> {
        return this.http.get(ServiceEndpointConstants.endpoints.USER.GET_ALL_USERS).pipe(
            map((response: any) => {
                return {
                    users: this.normalizeUsers(response.data.users),
                    success: response.data.success,
                }
            }),
            share());
    }

    public blockUser(userId: string, clientTimeStamp: string): Observable<IBlockUnblockResponse> {
        const req = {
            UserId: userId,
            ClientTimeStamp: clientTimeStamp
        }
        return this.http.post(ServiceEndpointConstants.endpoints.USER.BLOCK_USER, req).pipe(
            map((response: any) => {
                return response.data;
            }),
            share());
    }

    public unblockUser(userId: string, clientTimeStamp: string): Observable<IBlockUnblockResponse> {
        const req = { UserId: userId, ClientTimeStamp: clientTimeStamp }
        return this.http.post(ServiceEndpointConstants.endpoints.USER.UNBLOCK_USER, req).pipe(
            map((response: any) => {
                return response.data
            }),
            share());
    }

    public removeUser(userId: string, userName: string, clientTimeStamp: string): Observable<boolean> {
        const req = {
            UserId: userId,
            UserName: userName,
            ClientTimeStamp: clientTimeStamp
        }
        return this.http.post(ServiceEndpointConstants.endpoints.USER.REMOVE_USER, req).pipe(
            map((response: any) => {
                return response.data.success
            }),
            share());
    }

    public createNewAccount(newEmployee: IUserRegistration): Observable<IUserRegistrationResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.USER.CREATE_USER_ACCOUNT, newEmployee).pipe(
            map((response: any) => {
                return {
                    id: response.data.id,
                    success: response.data.success
                };
            }),
            share());
    }
    
    public updateUser(user: IUpdateUser): Observable<IUserResponse> {
         return this.http.post( ServiceEndpointConstants.endpoints.USER.UPDATE_USER, user ).pipe(
             map((response: any) => {
                 return {
                     id: response.data.id,
                     success: response.data.success
                 };
             }),
              share());
    }

    public getAllUserRoles(): Observable<IUserRoles> {
        return this.http.get(ServiceEndpointConstants.endpoints.USER.GET_ALL_USER_ROLES).pipe(
            map((response: any) => {
                return {
                    roles: response.data.roles,
                    success: response.data.success,
                };
            }),
            share());
    }

    public createRole(role: INewCraeteRole): Observable<boolean> {
        const req = {
            RoleName: role.roleName,
            clientTimeStamp: role.clientTimeStamp
        }
        return this.http.post(ServiceEndpointConstants.endpoints.USER.CREATE_ROLE, req).pipe(
            map((response: any) => {
                return response.data.success;
            }),
            share());
    }
    
    public getUserByUserId(userId: string): Observable<IUserResponse> {
        const config: IHttpRequestConfig = {
            params: {
                UserId: userId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.USER.GET_USER_BY_USERID, null, config).pipe(
            map((response: any) => {
                return {
                    user: this.normalizeUser(response.data.user),
                    id: userId,
                    success: response.data.success
                };
            }),
            share());
    }

    public addUserToRole(userrole: IUserRolecreate): Observable<IUserResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.USER.ADD_USER_TO_ROLE, userrole).pipe(
            map((response: any) => {
                return {
                    user: this.normalizeUser(response.data.user),
                    id: response.data.id,
                    success: response.data.success
                };
            }),
            share());
    }

    public removeUserRole(roleId: string, userId: string, clientTimeStamp: string): Observable<IUserResponse> {
        const req = {
            RoleId: roleId,
            UserId: userId,
            ClientTimeStamp: clientTimeStamp
        }
        return this.http.post(ServiceEndpointConstants.endpoints.USER.REMOVE_USER_ROLE, req).pipe(
            map((response: any) => {
                return {
                    user: this.normalizeUser(response.data.user),
                    id: response.data.id,
                    success: response.data.success
                };
            }),
            share());
    }

    public addUserToOrg(userOrg: IAddOrg): Observable<IUserResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.USER.ADD_USER_TO_ORG, userOrg).pipe(
            map((response: any) => {
                return {
                    user: this.normalizeUser(response.data.user),
                    id: response.data.id,
                    success: response.data.success
                }
            }),
            share());
    }

    public removeUserFromOrg(userId: string, orgId: string): Observable<IUserResponse> {
        const req = {
            UserId: userId,
            OrgId: orgId
        }
        return this.http.post(ServiceEndpointConstants.endpoints.USER.REMOVE_USER_FROM_ORG, req).pipe(
            map((response: any) => {
                return {
                    user: this.normalizeUser(response.data.user),
                    id: userId,
                    success: response.data.success
                };
            }),
            share());
    }

    public addUserToClient(client: IAddClient): Observable<IUserResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTSPOC.ADD_CLIENT_TO_USER, client).pipe(
            map((response: any) => {
                return {
                    user: this.normalizeUser(response.data.user),
                    id: response.data.id,
                    success: response.data.success
                };
            }),
            share());

    }
    public removeUserFromClient(userId: string, clientId: string): Observable<IUserResponse> {
        const req = {
            UserId: userId,
            ClientId: clientId
        }
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTSPOC.REMOVE_CLIENT_TO_USER, req).pipe(
            map((response: any) => {
                return {
                    user: this.normalizeUser(response.data.user),
                    id: userId,
                    success: response.data.success
                };
            }),
            share());
    }

    public getAllHmUsers(orgId: string, roleName: string): Observable<IHMUserResponse> {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId,
                RoleName: roleName
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.USER.GET_ALL_HMUSERS, null, config).pipe(
            map((response: any) => {
                return {
                    hmFlowUsers: response.data.hmFlowUsers,
                    success: response.data.success
                };
            }),
            share());
    }

    public createDepartment(department: INewCreateDepartment): Observable<IDepartmentResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.USER.CREATE_DEPARTMENT, department).pipe(
            map((response: any) => {
                return {
                    department: response.data.department,
                    departmentId: response.data.newDepartmentId,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateDepartment(department: IDepartments): Observable<IDepartmentResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.USER.UPDATE_DEPARTMENT, department).pipe(
            map((response: any) => {
                return {
                    department: response.data.department,
                    success: response.data.success
                };
            }),
            share());
    }

    public migrateLoginToSBaseEmail(req: IMigrateLoginRequest): Observable<IUserActionResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.USER.MIGRATE_LOGIN, req).pipe(
            map((response: any) => {
                return {
                    success: response.data.success,
                    message: response.data.message
                } as IUserActionResponse;
            }),
            share());
    }

    public offboardUser(req: IOffboardUserRequest): Observable<IUserActionResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.USER.OFFBOARD_USER, req).pipe(
            map((response: any) => {
                return {
                    success: response.data.success,
                    message: response.data.message
                } as IUserActionResponse;
            }),
            share());
    }

    private normalizeUser(user: any): IUser {
        user.id = user.id,
            user.firstName = user.firstName,
            user.lastName = user.lastName,
            user.email = user.email,
            user.userName = user.userName,
            user.roles = this.normalizeRoles(user.roles);
        return user;
    }

    private normalizeUsers(users: any): IUser[] {
        return users.map(user => {
            return this.normalizeUser(user);
        });
    }

    private normalizeRoles(roles: any): IRoleUser[] {
        return roles.map(role => {
            return {
                roleId: role.roleId,
                roleName: role.roleName
            } as IRoleUser;
        });
    }
}
